module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Обувь {city}","cities":{"kiev":"Киев","dp":"Днепр"}},"uk":{"title":"Взуття {city}","cities":{"kiev":"Київ","dp":"Дніпро"}}}')
  delete Component.options._Ctor
}
